import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Football américain",
    Baseball: "Baseball",
    Basketball: "Basketball",
    Boxing: "Boxe",
    Chess: "Echecs",
    Cricket: "Cricket",
    Darts: "Fléchettes",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Football",
    "Formula 1": "Formule 1",
    "Gaelic Football": "Football gaélique",
    "Generic Sport": "Generic Sport",
    Golf: "Golf",
    "Greyhound Racing": "Lévriers",
    Handball: "Handball",
    "Ice Hockey": "Hockey sur glace",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Rugby à 13",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Tennis de table",
    Tennis: "Tennis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} pour gagner",
    WinFirstRound: "{name} pour remporter le premier tour",
    FirstTouchdown: "{name} pour marquer un touché en premier",
    FirstTry: "{name} pour marquer un essai d'abord",
    TotalGoals: "{name} Total de buts",
    TotalRuns: "{name} Total de Runs",
    TotalPoints: "{name} Total Points",
    TopBatsman: "{name} pour être Top Batteur",
    TopBowler: "{name} pour être Top Lanceur",
    FirstScore: "{name} à marquer en premier"
  },
  PromoTexts: {
    Pick: "Faites vos choix",
    Bet: "Pari",
    Pays: "Gain"
  },
  DateTimeTexts: {
    Today: "Aujourd'hui",
    Tomorrow: "Demain",
    Live: "Réel"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Faites vos choix",
    Return: "Gain",
    Stake: "Pari",
    Draw: "X"
  },
  H2HTexts: {
    "Goals scored": "Buts marqués",
    Shots: "Tirs",
    "Shots on target": "Tirs cadrés",
    "Ball possession": "Possession de balle",
    "Goals conceded": "Buts encaissés",
    "Per match": "Par match",
    H2H: "Face à Face",
    W: "V",
    D: "N",
    L: "D"
  }
};
